import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Form, Formik } from "formik";
import performRequest from "../api/request";
import { Toast } from "../CustomComponent/toast";
import { FcViewDetails } from "react-icons/fc";
import FormSubmitButton from "../Components/layouts/formSubmitButton";
import Footer from "../Components/Footer/footer";
import { SiScheduleByClient } from "../SchemaInfo/info";
import { SiScheduledSchema } from "../Schemas/Schedule siteInspection/scheduledSiteInspection";
import { CustomErrorResponse } from "../CustomComponent/custom_error_response";
import LoadingPage from "../Components/layouts/loading";
import CustomInput from "../CustomComponent/custom_input";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import SimpleButton from "../Components/layouts/simple_button";

function EditSIschedulesByClient() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [extendDate, setExtendDate] = useState("");
  const [userSelectedSlots, setUserSelectedSlots] = useState([]);
  const [data, setData] = useState([]);
  const [isDateExpired, setIsDateExpired] = useState(false);
  const [initialValuesData, setInitialValuesData] =
    useState(SiScheduleByClient);
  const [fullyBookedDates, setFullyBookedDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableSlotsForSelectedDates, setAvailableSlotsForSelectedDates] =
    useState([]);
  const navigate = useNavigate();
  const [slotsCount, setSlotsCount] = useState(0);

  const handelSubmitPatch = (values) => {
    values.orderId = id;
    let data = { userSelectedSlots, values };
    if (slotsCount === 3) {
      setLoading(true);
      performRequest(
        "PATCH",
        `/bookSiteInspection/reschedulefinalAndPrefferedDates/${id}`,
        data
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Date Selected Successfully");
            navigate(`/schedule-site-inspection/${id}`);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    } else {
      Toast("error", `Please Select Any Three slots`);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0].split("-").reverse().join("-");
  };
  const getNext7Days = (startDateStr) => {
    const [day, month, year] = startDateStr.split("-");
    const startDate = new Date(`${year}-${month}-${day}`);

    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(startDate);
      date.setDate(date.getDate() + i);
      const formattedDate = date
        .toISOString()
        .split("T")[0]
        .split("-")
        .reverse()
        .join("-");
      dates.push(formattedDate);
    }

    return dates;
  };

  // Get Fully Booked Dates
  useEffect(() => {
    performRequest("GET", `/bookSiteInspection/getFullyBookedDates/`)
      .then((res) => {
        if (res.status === 200) {
          setFullyBookedDates(res.data.fullyBookedDates);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/bookSiteInspection/getOrderIdCount/${id}`)
      .then((res) => {
        if (res.status === 200) {
          let date = formatDate(res.data?.verifyOrderId.createdAt);
          if (date) {
            setExtendDate(date);
            setInitialValuesData({
              name: res.data?.verifyOrderId.fullName,
              email: res.data?.verifyOrderId.email,
              contactNumber: res.data?.verifyOrderId.contactNumber,
              orderId: res.data?.verifyOrderId.orderId,
              date1: res.data.finalDate,
            });
            if (!res.data?.getData) {
              let data = [res.data.verifyOrderId];
              setData(data);
              const mappedSlots = data.map((item) => ({
                date: item.finalDate,
                slots: [{ slot: item.timeSlot }],
              }));

              setUserSelectedSlots(mappedSlots);
              setSlotsCount(1);
              let checkingData = res.data.verifyOrderId.finalDate;
              checkDate(checkingData);
            } else {
              const mappedSlots = res?.data?.getData?.map((item) => ({
                date: item.prefferedDate,
                slots: [{ slot: item.timeSlot }],
              }));
              setData(res?.data?.getData);
              setUserSelectedSlots(mappedSlots);
              setSlotsCount(mappedSlots.length);
              let minDate = findMinimumDate(res.data.getData);
              checkDate(minDate);
            }
          }
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          Toast("error", err?.response?.data?.message);
        } else {
          Toast("error", err);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSlotSelect = (slot, date) => {
    setUserSelectedSlots((prevData) => {
      let newSlots = [...prevData];
      let existingDateIndex = newSlots.findIndex((d) => d.date === date);
      let totalSelectedSlots = prevData.reduce(
        (count, d) => count + d.slots.length,
        0
      );

      if (existingDateIndex !== -1) {
        let updatedSlots = [...newSlots[existingDateIndex].slots];
        let slotIndex = updatedSlots.findIndex((s) => s.slot === slot);

        if (slotIndex !== -1) {
          updatedSlots.splice(slotIndex, 1); // Remove slot
          newSlots[existingDateIndex] = {
            ...newSlots[existingDateIndex],
            slots: updatedSlots,
          };
          setSlotsCount((prev) => {
            const newCount = prev - 1;
            Toast("info", `${newCount} Remaining Slots`);
            return newCount;
          });
        } else {
          if (totalSelectedSlots < 3) {
            updatedSlots.push({ slot });
            newSlots[existingDateIndex] = {
              ...newSlots[existingDateIndex],
              slots: updatedSlots,
            };
            setSlotsCount((prev) => {
              const newCount = prev + 1;
              Toast("success", `${3 - newCount} Remaining Slots`);
              return newCount;
            });
          } else {
            Toast("error", "You have Selected Maximum Slots");
            return prevData;
          }
        }

        if (updatedSlots.length === 0) {
          newSlots.splice(existingDateIndex, 1);
        }
      } else {
        if (totalSelectedSlots < 3) {
          newSlots = [...prevData, { date, slots: [{ slot }] }];
          setSlotsCount((prev) => {
            const newCount = prev + 1;
            Toast("success", `${3 - newCount} Remaining Slots`);
            return newCount;
          });
        } else {
          Toast("error", "You have Selected Maximum Slots");
          return prevData;
        }
      }

      return [...newSlots];
    });
  };

  const handleRemoveSlot = (date, slot) => {
    setUserSelectedSlots((prevData) => {
      let updatedData = prevData
        .map((entry) =>
          entry.date === date
            ? { ...entry, slots: entry.slots.filter((s) => s.slot !== slot) }
            : entry
        )
        .filter((entry) => entry.slots.length > 0);

      setSlotsCount((prev) => prev - 1);

      return updatedData;
    });
  };

  const isDateDisabled = (date) => {
    const [dayE, monthE, yearE] = extendDate.split("-");
    const extendDateObj = new Date(`${yearE}-${monthE}-${dayE}`);
    const next7Days = getNext7Days(extendDate);
    const formattedDate = date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
    return (
      date < extendDateObj || // All previous dates
      next7Days.includes(formattedDate) || // Next 7 days including extendDate
      date.getDay() === 0 ||
      date.getDay() === 6 || // Disable weekends (Sunday & Saturday)
      fullyBookedDates.includes(formattedDate) // Fully booked dates
    );
  };

  useEffect(() => {
    if (selectedDate) {
      performRequest(
        "GET",
        `/bookSiteInspection/getSiteInspectionScheduelsByDate/${selectedDate}`
      )
        .then((res) => {
          if (res.status === 200) {
            setAvailableSlotsForSelectedDates(res.data.availableSlots);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    } else {
      setAvailableSlotsForSelectedDates([]);
    }
  }, [selectedDate]);

  const checkDate = (inputDate) => {
    const [day, month, year] = inputDate.split("-").map(Number);
    const inputDateObj = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (inputDateObj.getTime() === today.getTime()) {
      setIsDateExpired(true);
    }
  };

  const findMinimumDate = (data) => {
    if (!data || data.length === 0) return null;

    return data.reduce((min, current) =>
      new Date(current.prefferedDate.split("-").reverse().join("-")) <
      new Date(min.prefferedDate.split("-").reverse().join("-"))
        ? current
        : min
    ).prefferedDate;
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (isDateExpired) {
    return (
      <>
        <div className="page d-flex justify-content-center align-items-center">
          <div className="container-xl">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="card shadow-sm">
                  <div className="card-body text-center">
                    <h4 style={{ color: "#28a745" }}>Important Notice</h4>
                    <p style={{ color: "#212529" }}>
                      It seems the rescheduling and cancellation period for your
                      appointment has passed. We understand that unexpected
                      situations can arise, and we sincerely apologize for any
                      inconvenience caused. Our support team is here to assist
                      you with any further concerns or questions.
                    </p>
                    <p style={{ color: "#212529" }}>
                      Please feel free to{" "}
                      <a href="#" style={{ color: "#28a745" }}>
                        contact our team
                      </a>{" "}
                      for personalized assistance. We will do our best to help
                      you in any way possible.
                    </p>
                    <p style={{ color: "#212529" }}>
                      Thank you for your understanding and cooperation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          {data[0]?.finalDate || data.length > 0 ? (
            <div className="container-xl">
              <div className="page-header d-print-none">
                <div className="row g-2 align-items-center">
                  <div className="col">
                    <h2 className="page-title mb-1">
                      <FcViewDetails className="fs-2 me-1" />
                      Reschedule Site Inspection
                    </h2>
                  </div>
                </div>
              </div>
              <div className="card my-4">
                <div className="card-header">
                  <h2 className="page-title">Reschedule site schedules</h2>
                </div>

                <Formik
                  initialValues={initialValuesData}
                  validationSchema={SiScheduledSchema}
                  enableReinitialize
                  onSubmit={handelSubmitPatch}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Name
                              </label>
                              <div className="col-lg-9">
                                {" "}
                                <CustomInput name="name" type="text" />
                                {props.touched.name && props.errors.name && (
                                  <p className="text-danger">
                                    {props.errors.name}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Email
                              </label>
                              <div className="col-lg-9">
                                {" "}
                                <CustomInput name="email" type="text" />
                                {props.touched.email && props.errors.email && (
                                  <p className="text-danger">
                                    {props.errors.email}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Contact Number
                              </label>
                              <div className="col-lg-9">
                                <CustomInput name="contactNumber" type="text" />
                                {props.touched.contactNumber &&
                                  props.errors.contactNumber && (
                                    <p className="text-danger">
                                      {props.errors.contactNumber}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label htmlFor="" className="form-label col-lg-3">
                                Chosen Slots
                              </label>
                              <div className=" col-lg-9">
                                <div className="card">
                                  <div className="card-header text-center">
                                    <div className="col-4 form-label">
                                      {" "}
                                      Select Slots
                                    </div>{" "}
                                    <div className="col-4 form-label">
                                      Available: 3
                                    </div>{" "}
                                    <div className="col-4 form-label">
                                      Booked: {slotsCount}
                                    </div>
                                  </div>
                                  <div className="card-body">
                                    <div className="row row-deck">
                                      {userSelectedSlots.length > 0 ? (
                                        userSelectedSlots.map(
                                          (dateEntry, index) => (
                                            <div
                                              key={index}
                                              className="col-lg-4 col-md-6"
                                            >
                                              <div className="card my-1">
                                                <div className="card-body">
                                                  <p className="card-text fw-bold">
                                                    Date: {dateEntry.date}
                                                  </p>
                                                  <div className="d-flex flex-wrap">
                                                    {dateEntry.slots.map(
                                                      (slotObj, slotIdx) => (
                                                        <span
                                                          key={slotIdx}
                                                          className="badge bg-blue-lt m-1 d-flex align-items-center px-3 py-2 rounded-pill shadow-sm"
                                                          style={{
                                                            cursor: "pointer",
                                                            fontSize: "0.9rem",
                                                          }}
                                                        >
                                                          {slotObj.slot}
                                                          <span
                                                            className="ms-2 text-red fw-bold"
                                                            onClick={() =>
                                                              handleRemoveSlot(
                                                                dateEntry.date,
                                                                slotObj.slot
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              marginLeft: "8px",
                                                              transition:
                                                                "color 0.3s",
                                                            }}
                                                            onMouseEnter={(e) =>
                                                              (e.target.style.color =
                                                                "#ff4d4d")
                                                            }
                                                            onMouseLeave={(e) =>
                                                              (e.target.style.color =
                                                                "white")
                                                            }
                                                          >
                                                            ✖
                                                          </span>
                                                        </span>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        )
                                      ) : (
                                        <p>You Haven't Selected any Slot</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="mb-1 row">
                              <label className="col-lg-3 form-label required">
                                Instructions
                              </label>
                              <div className="col-lg-9">
                                <ol>
                                  <li>
                                    Deselect the chosen slot to change the time
                                    slot and date.
                                  </li>
                                  <li>
                                    You can select a maximum of three slots.
                                  </li>
                                  <li>
                                    For each new slot, you can select the new
                                    date.
                                  </li>
                                  <li>
                                    You can reschedule three time slots for a
                                    single date or one time slot for each new
                                    date.
                                  </li>
                                  <li>
                                    After selecting a date, you'll see available
                                    time slots and can choose from them.
                                  </li>
                                </ol>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Date
                              </label>
                              <div className="col-lg-9">
                                <DatePicker
                                  selected={
                                    props.values.date1
                                      ? new Date(
                                          props.values.date1
                                            .split("-")
                                            .reverse()
                                            .join("-")
                                        )
                                      : null
                                  }
                                  onChange={(date) => {
                                    if (date) {
                                      const formattedDate = date
                                        .toLocaleDateString("en-GB", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                        })
                                        .replace(/\//g, "-");
                                      props.setFieldValue(
                                        "date1",
                                        formattedDate
                                      );
                                      setSelectedDate(formattedDate);
                                    }
                                  }}
                                  filterDate={(date) => {
                                    return !isDateDisabled(date);
                                  }}
                                  minDate={new Date()} // Disable past dates
                                  className="form-control w-100"
                                  wrapperClassName="w-100"
                                  placeholderText={
                                    !extendDate
                                      ? "Please Select Order Booking"
                                      : "DD-MM-YYYY"
                                  }
                                  disabled={!extendDate ?? "true"}
                                  dateFormat="dd-MM-yyyy"
                                />

                                {props.touched.date1 && props.errors.date1 && (
                                  <p className="text-danger">
                                    {props.errors.date1}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label className="form-label col-lg-3">
                                Time
                              </label>
                              <div className="col-lg-9">
                                <div className="card">
                                  <div className="card-body">
                                    <div className="row text-center">
                                      {!props.values.date1 ? (
                                        <p> Please Select Date </p>
                                      ) : availableSlotsForSelectedDates?.length >
                                        0 ? (
                                        availableSlotsForSelectedDates?.map(
                                          (slot, index) => (
                                            <div
                                              key={index}
                                              className="col-md-3"
                                            >
                                              <div
                                                className={`card my-1 ${
                                                  userSelectedSlots.some(
                                                    (d) =>
                                                      d.date ===
                                                        props.values.date1 &&
                                                      d.slots.some(
                                                        (s) => s.slot === slot
                                                      )
                                                  )
                                                    ? "bg-secondary text-white"
                                                    : ""
                                                }`}
                                                onClick={() =>
                                                  handleSlotSelect(
                                                    slot,
                                                    props.values.date1
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  opacity:
                                                    userSelectedSlots.some(
                                                      (d) =>
                                                        d.date ===
                                                          props.values.date1 &&
                                                        d.slots.some(
                                                          (s) => s.slot === slot
                                                        )
                                                    )
                                                      ? 0.5
                                                      : 1,
                                                }}
                                              >
                                                <div className="card-body">
                                                  <p className="card-text">
                                                    {slot}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        )
                                      ) : (
                                        <p>
                                          All Slots are booked, Choose Another
                                          Date
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          {/* <SimpleButton onClick={handleCancelSchedule} type="danger"  buttonText="Cancel Schedule" /> */}
                          <FormSubmitButton buttonText="Submit" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
              <div
                className="card shadow-lg p-5"
                style={{ maxWidth: "480px", width: "100%" }}
              >
                <div className="text-center">
                  <h1 className="text-warning fw-bold">Oops! Not Found</h1>
                  <p className="text-muted mt-3">
                    The page or information you are looking for doesn't seem to
                    exist. It might have been moved, deleted, or perhaps the
                    link is incorrect.
                  </p>
                  <hr className="my-4" />
                  <p className="text-muted">
                    If you believe this is an error or need further assistance,
                    feel free to contact us.
                  </p>
                  <div className="mt-3">
                    <p className="text-primary fw-semibold mb-1">
                      Email: contact@kryzen.com
                    </p>
                    <p className="text-primary fw-semibold">
                      Mobile: 9870-424-425
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <Footer />
        </div>
      </div>
    </>
  );
}

export default EditSIschedulesByClient;
